<script>
  import { t } from "../../core";

  export let url: string;
  export let name: string;
  export let isNew: boolean = false;
</script>

<div class="item">
  <svg class="icon" width="16" height="20" aria-label="document">
    <use xlink:href="#document" />
  </svg>
  <div class="item-name">
    <a href={url} target="_blank" class="link" rel="noopener noreferrer">
      {name}
    </a>
    {#if isNew}
      <span class="item-badge">{t("Item.Document.New")}</span>
    {/if}
  </div>
</div>

<style lang="scss">
  .item {
    display: flex;
    column-gap: 10px;
    margin-bottom: 10px;
  }

  .icon {
    fill: $key-color;
  }

  .item-badge {
    background: $warning-color;
    color: $text-reverse-color;
    font-size: 10px;
    display: inline-block;
    padding: 2px 4px;
    margin-left: 6px;
    line-height: 1;
  }
</style>
